import styled from 'styled-components';

import { heading } from 'quarks/interpolations/heading';

const Heading = styled.h1`
  ${heading}
`;

export default Heading;
